/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * Base error class used to provide extended definition to the Error type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
class BaseError {
    constructor() {
        Error.apply(this, arguments as any);
    }
}

BaseError.prototype = new Error();

export default BaseError;
